// extracted by mini-css-extract-plugin
export default {"customerChatRoomContentSec":"CustomerChatRoom_customerChatRoomContentSec__8Hkin","customerChatRoomSendSec":"CustomerChatRoom_customerChatRoomSendSec__zjRZa"};